module.exports = __webpack_public_path__ + "img/account_webshop_circle.91cdc27.svg";